export default "__VITE_ASSET__HBWPblaw__"